import { render, staticRenderFns } from "./TestItemQuestion.vue?vue&type=template&id=2d97a667&scoped=true&"
import script from "./TestItemQuestion.vue?vue&type=script&lang=js&"
export * from "./TestItemQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97a667",
  null
  
)

export default component.exports